import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlarmRuleActionDto, AlarmRuleActionType } from '../../../../../../types/dtos/alarm-rule-action.dto';
import { BaseRule } from '../../base-rule';

export abstract class BaseRuleAction extends BaseRule {
  abstract override getType(): AlarmRuleActionType;

  override createFormGroup(action: Omit<AlarmRuleActionDto, 'alarm_rule_id'>): FormGroup {
    const actionForm = new FormGroup({
      id: new FormControl<number | null>(action.id ?? null),
      type: new FormControl(action.type, Validators.required),
      ...this.getFromControls(),
    });

    const config = {
      ...action.config as {},
      ...(action.overrideConfig ?? {}),
    };

    actionForm.patchValue({
      ...this.configToFrom(config),
    }, {emitEvent: false});

    return actionForm;
  }
}